var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"tooltip",staticClass:"ui-tooltip",class:_vm.tooltipClasses,attrs:{"tabindex":"-1","type":"button"}},[_c('ui-icon',{attrs:{"icon":"ui-tooltip"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }